/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Ladda = require('ladda');
var BreadcrumbView = require('common/views/BreadcrumbView');

var Radio = require('backbone.radio');

var SubmitContact = require('../services/SubmitContact');
var COCInternalSidebarNavView = require('../../internal-dashboard/views/COCInternalSidebarNavView');

require('../styles/COCContactNewView.css');
var tmplCOCContactNewView = require('../templates/COCContactNewView.hbs');
var COCContactFormView = require('./COCContactFormView');

module.exports = Marionette.LayoutView.extend({
  template: tmplCOCContactNewView,

  className: 'coc-contact-new-view container-fluid',

  ui: {
    sideBar: '.side-bar-container',
    breadCrumbContainer: '.breadcrumb-container',
    submitButton: '.btn-submit',
    contactFormContainer: '.contact-form-container'
  },

  regions: {
    breadCrumbContainer: '@ui.breadCrumbContainer',
    sideBar: '@ui.sideBar',
    contactFormContainer: '@ui.contactFormContainer'
  },

  events: {
    'click @ui.submitButton': 'onClickSubmit'
  },

  templateHelpers: function() {},

  onBeforeShow: function() {
    this.showChildView('sideBar', new COCInternalSidebarNavView());
    this.showChildView(
      'breadCrumbContainer',
      new BreadcrumbView({
        breadcrumbs: [
          {
            text: 'Home',
            link: '#coc/dashboard'
          },
          {
            text: 'Create A New Contact'
          }
        ]
      })
    );
    this.contactForm = new COCContactFormView({ model: this.model });
    this.showChildView('contactFormContainer', this.contactForm);
  },

  onClickSubmit: function(e) {
    e.preventDefault();
    var self = this;
    this.validate().done(
      function() {
        var laddaContext = Ladda.create(this.ui.submitButton.get(0));
        laddaContext.start();
        SubmitContact(self.getFormData())
          .done(function(contact) {
            laddaContext.stop();
            Radio.channel('navigate').trigger('show:int:coc:contact', contact.contactId);
          })
          .fail(function() {
            laddaContext.stop();
          });
      }.bind(this)
    );
  },

  validate: function() {
    return this.ui.contactFormContainer.parsley().whenValidate();
  },

  getFormData: function() {
    return this.contactForm.getFormData();
  }
});
